import PropTypes from "prop-types";
import React, { useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Form } from "formsy-semantic-ui-react";
import { Dropdown } from "semantic-ui-react";
import { getCropsList } from "../../actions/Farms/crops";

const SelectCrop = ({
  actions: { getCropsList },
  cropsList,
  isFetching,
  required,
  error,
  minItemForSearch,
  onChange,
  native,
  ...extraProps
}) => {
  useEffect(() => {
    getCropsList();
  }, [getCropsList]);

  const options = useMemo(
    () =>
      cropsList
        .sort((c1, c2) => c1.name.localeCompare(c2.name))
        .map(content => ({
          key: content.id,
          text: content.name,
          value: content.id
        })),
    [cropsList]
  );

  useEffect(() => {
    if (required && options && options.length === 1) {
      onChange(null, { options, value: options[0].value });
    }
  }, [options]); // eslint-disable-line

  const props = {
    placeholder: "Select crop",
    fluid: true,
    ...extraProps,
    error,
    closeOnBlur: true,
    onChange,
    loading: isFetching,
    selection: true,
    required,
    search: options.length >= minItemForSearch,
    noResultsMessage: "Nothing was found",
    options
  };
  return native ? <Dropdown {...props} /> : <Form.Dropdown {...props} />;
};

SelectCrop.propTypes = {
  actions: PropTypes.object.isRequired,
  cropsList: PropTypes.array.isRequired,
  disabled: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  minItemForSearch: PropTypes.bool,
  native: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool.isRequired,
  showArchived: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.array.isRequired,
    PropTypes.number.isRequired
  ])
};

SelectCrop.defaultProps = {
  cropsList: [],
  disabled: false,
  error: false,
  isFetching: false,
  minItemForSearch: 10,
  native: false,
  onChange: () => {},
  required: false,
  showArchived: false,
  value: []
};

const mapStateToProps = ({ crops: { data, isFetching } }) => {
  return {
    cropsList: data,
    isFetching
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      getCropsList
    },
    dispatch
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectCrop);
